module.exports = __webpack_public_path__ + "static/media/Phung-Tran-Huy-Nhat.397ad222.png";